import { mixed, object, string, type ObjectSchema } from 'yup';
import type { FieldValues } from './types';


export const validationSchema: ObjectSchema<FieldValues> = object({
  fileInfo: mixed().optional().nullable(),

  slug: string().trim().required('Slug is required'),

  serviceNameEn: string().trim().required(),
  serviceNameUk: string().trim().required(),
  serviceNamePl: string().trim().required(),
  serviceNameRu: string().trim().required(),

  serviceSubtitleEn: string().trim().required(),
  serviceSubtitleRu: string().trim().required(),
  serviceSubtitleUk: string().trim().required(),
  serviceSubtitlePl: string().trim().required(),

  serviceShortnamePl: string().trim().required(),
  serviceShortnameUk: string().trim().required(),
  serviceShortnameRu: string().trim().required(),
  serviceShortnameEn: string().trim().required(),

  seoTitleEn: string().trim().required(),
  seoTitlePl: string().trim().required(),
  seoTitleRu: string().trim().required(),
  seoTitleUk: string().trim().required(),

  seoDescriptionUk: string().trim().required(),
  seoDescriptionRu: string().trim().required(),
  seoDescriptionEn: string().trim().required(),
  seoDescriptionPl: string().trim().required(),

}).required();
